// ATTN we use this constants in data dump
const abTests = {
  upchargeInfoPayment: 'UpchargeInfoPayment', // PF-1397
  storylyAlternativePosition: 'storyly:alternativePosition', // CRO-142
  homeQueueWidget: 'home:queueWidget', // CRO-51
  tyAllUpgradePlans: 'ty:allUpgradePlans', // CRO-130
  registerWithoutPassword: 'register:withoutPassword', // CRO-162
  inAppMessagesCenter: 'inAppMessagesCenter', // CRO-69
  paymentBeam: 'payment:beam', // CRO-167
  paymentWithoutAddressAutocomplete: 'payment:withoutAddressAutocomplete', // CRO-145
  paymentDisableLogoLink: 'payment:disableLogoLink', // CRO-170
  paymentRegisterInPayment: 'payment:registerInPayment', // CRO-148
  paymentMarketingMessage: 'payment:marketingMessage', // CRO-155
  spHowItWorksUpdate: 'sp:howItWorksUpdate', // CRO-125
  saksAddDashHudson: 'saks:addDashHudson', // CRO-137
  homeChangeBannerText: 'home:changeBannerText', // CRO-144
  homeHeroQuizLink: 'home:heroQuizLink', // CRO-151
  homeSSRApiCache: 'home:ssrApiCache', // EP-2133
  spShortVersion: 'sp:shortVersion', // CRO-84
  quizButtonsColorChange: 'quiz:buttonsColorChange', // CRO-139
  newReferralProgram: 'newReferralProgram', // EP-2060
  queueStickyBanner: 'queue:stickyBanner', // EP-2100
  csVideoPage: 'cs:videoPage', // EP-2122
  queueCaseSubscriptionBanner: 'queue:CaseSubscriptionBanner', // EP-2123
} as const

export type AbTestName = typeof abTests[keyof typeof abTests]


export default abTests
